export function setProducts (state, products) {
  state.products = products;
  // Definir los tipos de productos en el state de products > types
  let types = []
  products.forEach(element => {
    types.push(element.product_type)
  });
  // Filtro para quitar los que vienen en null o en blanco
  state.types = [...new Set(types)].filter((el) => el != null && el != "")
}

export function setProduct (state, product){
  state.selectedProduct = product
}

export function setUserProducts (state, products){
  state.UserProducts = products
}

export function productsError(state, payload){
  state.error = true
  state.errorMessage = payload
  state.products = []
}